/* eslint-disable no-extra-parens */

import styled from 'styled-components'
import {
  DEVICE,
  NAVIGATION_MENU_EXPANDED_WIDTH_DESKTOP,
  NAVIGATION_BAR_COLLAPSED_SIZE,
} from '../../util/constants'

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;

  @media ${DEVICE.tabletL} {
    flex-direction: row;
    width: ${({ isNavMenuOpen }) =>
      !isNavMenuOpen
        ? '100vw'
        : `calc(100vw + ${
            NAVIGATION_MENU_EXPANDED_WIDTH_DESKTOP -
            NAVIGATION_BAR_COLLAPSED_SIZE.desktop.width
          }px)`};
    transition: width 0.25s;
    height: 100vh;
  }
`

export const ContentRegion = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: scroll;

  @media ${DEVICE.tabletL} {
    width: max-content;
    overflow-x: hidden;
    flex-grow: 1;
  }
`

export const PageContent = styled.main`
  flex: 1 0 auto;

  .two-column-layout {
    @media ${DEVICE.laptopG} {
      display: grid;
      grid-template-columns: 1fr 10fr 1fr;
      max-width: 1317px;
    }
  }

  .two-column-layout__wrapper {
    @media ${DEVICE.laptopG} {
      display: flex;
      flex-direction: row;
      grid-column: 2 / 3;
    }
  }

  .two-column-layout__main {
    @media ${DEVICE.laptopG} {
      margin-right: 40px;
    }
  }

  .two-column-layout__aside {
    @media ${DEVICE.laptopG} {
      flex: 0 0 338px;
    }
  }

  .util-large-only {
    display: none;

    @media ${DEVICE.laptopG} {
      display: block;
    }
  }

  .util-small-only {
    display: block;

    @media ${DEVICE.laptopG} {
      display: none;
    }
  }
`
